import HttpClient from '../httpClient';
import RootService from './rootService';
import CurrentUser from '../models/currentUser';

const CurrentUserService = {

  parseCurrentUser: function(response) {
    if (!response) return null;

    return {
      id: response.id,
      _links: response._links,
      _forms: response._forms
    };
  },

  getCurrentUser: function() {
    return RootService.getRoot().then(root => {
      const currentUserLink = root.getLink('dm:me:v1');

      return HttpClient.get(currentUserLink.href).then(response => {
        const currentUserProps = CurrentUserService.parseCurrentUser(response);
        return new CurrentUser(currentUserProps);
      });
    });
  }

};

export default CurrentUserService;



// WEBPACK FOOTER //
// ./src/api/services/currentUserService.js